// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vQmc","tabsBox":"styles_tabsBox__Wfk01","createButton":"styles_createButton__1ykzW"};